"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'tools.askForVoucher.name': 'Żądanie Vouchera',
    'tools.askForVoucher.description': 'Wykryj prośby o vouchery lub zniżki w wiadomościach użytkownika i uruchom akcje vouchera po stronie klienta',
};
